import React from 'react';
import { Typography, Stack, Box, Chip } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSubscriptions, useSubscriptionsFromCee } from './utils';
import { FirebaseUser, PersonProduct } from './types';

const renderStatus = (status: string) => {
  if (status === 'Active') {
    return <Chip label="Aktivt" color="success" variant="filled" />;
  }

  if (status === 'Cancelled') {
    return <Chip label="Avslutat" color="error" variant="filled" />;
  }
};

const Subscriptions = ({
  user,
  ceeProducts,
  loading,
}: {
  user: FirebaseUser | null;
  ceeProducts: PersonProduct[] | null;
  loading: boolean;
}) => {
  const { subscriptions } = useSubscriptions(user?.products);
  const { ceeSubscriptions } = useSubscriptionsFromCee(ceeProducts);

  return (
    <Stack spacing={2}>
      <Box>
        <Typography sx={{ fontSize: '16px' }} color="text.secondary" gutterBottom>
          Abonnemang från Firestore
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={{}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Produkt</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left">Uppdaterad</TableCell>
                <TableCell align="left">Start</TableCell>
                <TableCell align="left">Tillgång tom</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subscriptions?.map((row) => (
                <TableRow
                  key={row.key}
                  sx={{
                    '&:last-child td, &:last-child th': {
                      border: 0,
                    },
                  }}
                >
                  <TableCell align="left">{row.productName}</TableCell>
                  <TableCell align="left">{renderStatus(row.status)}</TableCell>
                  <TableCell align="left">{row.changedAt}</TableCell>
                  <TableCell align="left">{row.start}</TableCell>
                  <TableCell align="left">{row.accessUntil}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box>
        <Typography sx={{ fontSize: '16px' }} color="text.secondary" gutterBottom>
          Abonnemang från CEE
        </Typography>
        <TableContainer component={Paper}>
          <Table sx={{}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Produkt</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left">Start</TableCell>
                <TableCell align="left">Tillgång tom</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ceeSubscriptions?.map((row) => (
                <TableRow
                  key={row.key}
                  sx={{
                    '&:last-child td, &:last-child th': {
                      border: 0,
                    },
                  }}
                >
                  <TableCell align="left">{row.productName}</TableCell>
                  <TableCell align="left">{renderStatus(row.status)}</TableCell>
                  <TableCell align="left">{row.start}</TableCell>
                  <TableCell align="left">{row.accessUntil}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Stack>
  );
};

export default Subscriptions;
